import React, { useState } from 'react';
import { TYPO, R, S, SHADCN } from '../theme';
import { useEntityAccent } from './EntityAccent';

// Titre du mois cliquable.
// Clic → révèle un chip discret avec les jours ouvrés restants (easter egg utile).
export default function MonthTitle({ title, now }) {
  const [revealed, setRevealed] = useState(false);
  const accent = useEntityAccent();
  const chipBg     = accent ? `color-mix(in oklch, ${accent} 12%, transparent)` : 'transparent';
  const chipBorder = accent ? `color-mix(in oklch, ${accent} 40%, transparent)` : SHADCN.border;
  const chipColor  = accent || SHADCN.mutedFg;

  // Mois passé (now = null) : titre statique, pas de chip.
  if (!now) return <span style={{ ...TYPO.h1, color: SHADCN.fg, display: 'inline-block' }}>{title}</span>;

  const year = now.getFullYear();
  const month = now.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  let ouvresRestants = 0;
  for (let d = now.getDate() + 1; d <= daysInMonth; d++) {
    const wd = new Date(year, month, d).getDay();
    if (wd !== 0 && wd !== 6) ouvresRestants++;
  }
  const jourSem = now.getDay();
  const aujOuvre = jourSem !== 0 && jourSem !== 6;

  return (
    <>
      <button
        type="button"
        onClick={() => setRevealed(v => !v)}
        title={revealed ? 'Masquer' : 'Tu sais quoi ?'}
        style={{ all: 'unset', cursor: 'pointer', ...TYPO.h1, color: SHADCN.fg, display: 'inline-block' }}
      >
        {title}
      </button>
      <div style={{
        marginTop: 8,
        overflow: 'hidden',
        maxHeight: revealed ? 32 : 0,
        opacity: revealed ? 1 : 0,
        transform: revealed ? 'translateY(0)' : 'translateY(-4px)',
        transition: `max-height ${SHADCN.durSlow} ${SHADCN.easeOut}, opacity ${SHADCN.durBase} ${SHADCN.easeOut}, transform ${SHADCN.durBase} ${SHADCN.easeOut}`,
      }}>
        <span style={{
          ...TYPO.caption,
          ...TYPO.num,
          color: chipColor,
          background: chipBg,
          padding: `2px ${S[2]}px`,
          border: `1px solid ${chipBorder}`,
          borderRadius: R.pill,
        }}>
          {ouvresRestants} jour{ouvresRestants > 1 ? 's' : ''} ouvré{ouvresRestants > 1 ? 's' : ''} restant{ouvresRestants > 1 ? 's' : ''}{aujOuvre ? ' (hors aujourd’hui)' : ''}
        </span>
      </div>
    </>
  );
}
